import { createContext, useContext } from 'react';

import { CustomUser } from '../generated-api';

export const CurrentUserContext = createContext<{
  user: CustomUser | undefined;
  refetchUser: () => Promise<unknown>;
}>({
  user: undefined,
  refetchUser: async () => {},
});

export const useCurrentUser = () => useContext(CurrentUserContext);

// Check if user joined in the last 30 seconds (likely a new signup)
export const hasUserJustSignedUp = (user: CustomUser) =>
  new Date(user.date_joined) >= new Date(Date.now() - 30000);
